import { useApiClient } from '../../client.js'
import { BOOKSY_PAY_SETTINGS_ENDPOINT } from '../consts.ts'

export function getBooksyPaySettings (businessId) {
  const apiClient = useApiClient()

  return apiClient.get({
    url: BOOKSY_PAY_SETTINGS_ENDPOINT,
    urlParams: {
      businessId,
    },
  })
}
